import React, { useEffect, useMemo, useRef, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { CaseLoadUser, CoachInfo, DataPeriod, OnboardingState, StudentInfo, TeacherInfo } from "../../../../../../store/onboarding/types";
import useUserRole from "../../../../../../utils/hooks/useUserRole";
import ToolBar from "../common/ToolBar";
import { ApplicationState } from "../../../../../../store";
import { DataFilterState } from "../../../../../../store/dataFilter/types";
import RecommendationsSection from "./RecommendationsSection";
import { getInterventionGroups, getRecommendations, hideInterventionPlanModal, resetDiscontinuedUserDetail, resetGroupCreated } from "../../../../../../store/onboarding/cases/actions";
import { bindActionCreators, Dispatch } from "redux";
import { changeIntGroupAssigmentCollapsedSettings, getCaseLoadUsers, getCoaches, getTeachers, openGroupReorderModal, openInterventionStatsModal } from "../../../../../../store/onboarding/actions";
import { push } from "connected-react-router";
import { Accordion, Alert, Button, Card, Collapse, Image } from "react-bootstrap";
import LoadingIndicator from "../../../../../common/onboarding/LoadingIndicator";
import { useLocation } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp, faCaretDown, faCaretRight } from "@fortawesome/free-solid-svg-icons";
import SvgCircle from "../common/SvgCircle";
import { getSkillFocuses, openOverviewModel } from "../../../../../../store/groups/actions";
import InterventionStatsModal from "./InterventionStatsModal";
import InterventionFidelityTour from "../../../tours/InterventionFidelityTour";
import FidelityChartTour from "../../../tours/FidelityChartTour";
import { CaseInterventionGroup, InterventionGroup } from "../../../../../../store/onboarding/cases/types";
import InterventionsGroup from "../assigment/InterventionsGroup";
import useGroupCardDragging from "../../../../../common/reading-interventions/intervention-tools/recommend-groups/hooks/useGroupCardDragging";
import { createBrowserHistory } from "history";
import useActiveTab from "../../../../parent-dashboard/useActiveTab";
import AddInterventionModal from "../../../../../common/onboarding/third-step/find-intervention/AddInterventionModal";
import useHighlightGroupCard from "../../../../../common/reading-interventions/intervention-tools/recommend-groups/hooks/useHighlightGroupCard";
import GroupReorderModal from "./GroupReorderModal";
import useInterventionGroupReorder from "./hooks/useInterventionGroupReorder";

type OwnProps = {
  student?: StudentInfo;
  isYourAssignments?: boolean;
  activeTab?: string;
};

type StateProps = {
  collapsedIntGroupAssignmentsIds: number[];
  caseLoadUserList: CaseLoadUser[];
  caseInterventionGroups: CaseInterventionGroup;
  isGroupCreated: boolean;
  selectedInterventionGroup?: InterventionGroup;
  isLoading: {
    getCaseLoadUsers: boolean;
    getInterventionGroups: boolean;
    createInterventionGroup: boolean;
    getTeachers: boolean;
    getCaseId?: string;
    discontinueIntGroupInt: boolean;
  };
  errors: {
    getCaseLoadUsers: any;
    getInterventionGroups: any;
  }
};

type DispatchProps = {
  push: (location: string) => any;
  changeIntGroupAssigmentCollapsedSettings: (args: {
    id: number;
    collapsed?: boolean;
  }) => any;
  getCaseLoadUsers: () => any;
  getInterventionGroups: (archived?: boolean, tabName?: string, studentId?: number ) => any;
};

type Props = OwnProps & StateProps & DispatchProps;
  
const CaseLoadUserList = ({ 
  student, 
  isYourAssignments, 
  activeTab, 
  caseLoadUserList,
  changeIntGroupAssigmentCollapsedSettings,
  caseInterventionGroups,
  isGroupCreated,
  selectedInterventionGroup,
  isLoading
}: Props) => {
  const { isParent, isSupervisor, isTeacher, isCoach, isDistrictOwner } = useUserRole();
  const dispatch = useDispatch();
  const tabName = useSelector<ApplicationState>((s)=> s.cases.tabName);

  const [ isStudentDetail, setIsStudentDetail] = useState<boolean>(false);
  const [openShareData, setOpenShareData] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [collapsedStates, setCollapsedStates] = useState<any>({});
  // const [intGrpIDsWithEditAccess, setIntGrpIDsWithEditAccess] = useState<number[]>([]);
  // const [intGrpIDsWithReadAccess, setIntGrpIDsWithReadAccess] = useState<number[]>([]);
  const [caseLoadUsers, setCaseLoadUsers] = useState<CaseLoadUser[]>([]);
  //const [caseInterventionGroups, setcaseInterventionGroups] = useState<CaseInterventionGroup>({});

  const { groupReorderSorting } = useInterventionGroupReorder()

  const isDiscontinuedUserDetail = useSelector<ApplicationState, {isDiscontinued: boolean, discontinueCaseId: number}>(
    (s) => s.cases.isDiscontinuedUserDetail
  )
  const { groupSearch, showArchivedGroups, groupSort, exitedStudentsGroup } = useSelector<
    ApplicationState,
    DataFilterState
  >((s) => s.dataFilter);

  const displayGroupChange = useSelector<
    ApplicationState
  >((s) => s.cases.displayGroupName);

  const listOrderSwitch = useSelector<
    ApplicationState,
    boolean | undefined
  >((s) => s.cases.listOrderSwitch);

  const currentUserInfo = useSelector(
    (s: ApplicationState) => s.auth.userInfo
  );

  useEffect(() => { 
    setCaseLoadUsers(caseLoadUserList);
  },[caseLoadUserList])

  const location = useLocation();

  useEffect(() => {
    let queryStr = '';
    // Extract tab value from URL query params
    const searchParams = new URLSearchParams(location.search);
    const urlTab = searchParams.get('tab');
    
    if(activeTab && (activeTab == 'groups/reading' || activeTab == 'groups/behavior')) {
      if(activeTab == 'groups/reading') {
        queryStr = '?is_behavior=0'
      }
      if(activeTab == 'groups/behavior') {
        queryStr = '?is_behavior=1'
      }
      if(urlTab == 'archived') {
        queryStr += '&archived=true'
      }
      dispatch<any>(getCaseLoadUsers(queryStr))
      .then((caseLoadUserList: CaseLoadUser[]) => setCaseLoadUsers(caseLoadUserList));
    } else {
      if(student) {
        queryStr += `?student_id=${student.id}`
        if(urlTab == 'archived') {
          queryStr += '&archived=true'
        } else if(exitedStudentsGroup && (urlTab == 'exited_groups')) {
          queryStr += '&exited=true'
        }
        if(isDistrictOwner) {
          queryStr += `${listOrderSwitch ? '&organize_by=coach': '&organize_by=teacher'}`
        }
       dispatch<any>(getCaseLoadUsers(queryStr))
       .then((caseLoadUserList: CaseLoadUser[]) => setCaseLoadUsers(caseLoadUserList));
      }
    }
  },[activeTab, location.search, student, listOrderSwitch])

  // useEffect(() => { 
  //   setcaseInterventionGroups(caseInterventionGroups);
  // },[caseInterventionGroups])

  useEffect(() => {
    Object.keys(collapsedStates).forEach((caseId) => {
      if (collapsedStates[caseId]) {
        const caseLoadId = caseId.split('_')[3];
        if (!caseInterventionGroups[caseLoadId] || !caseInterventionGroups[caseLoadId].length) { // Fetch only if not already loaded
          setCollapsedStates((prevStates: any) => ({
            ...prevStates,
            [caseId]: !prevStates[caseId], // Toggle the state for the specific case_id
          }));
        }
      }
    });
  }, [caseInterventionGroups])
  
  useEffect(() => {
    if(isDiscontinuedUserDetail?.isDiscontinued) {
      if(Object.keys(caseInterventionGroups).length && !caseInterventionGroups[isDiscontinuedUserDetail.discontinueCaseId]?.length) {
        setCaseLoadUsers(caseLoadUsers?.filter((caseLoad) => caseLoad.case_id != isDiscontinuedUserDetail.discontinueCaseId))
        dispatch(resetDiscontinuedUserDetail())
      }
    }
},[isDiscontinuedUserDetail, caseInterventionGroups])
  

  const currentDataPeriod = useSelector<
      ApplicationState,
      DataPeriod | undefined
    >((s) => s.onboarding.currentDataPeriod);
  
  const isStudentDetailReducer = useSelector<
    ApplicationState
  >((s) => s.cases.isStudentDetail);

  useEffect(() => {
    setIsStudentDetail(!!isStudentDetailReducer);
  },[displayGroupChange,isStudentDetailReducer])

  const showRecommendedGroups = useSelector<
      ApplicationState,
      boolean | undefined
    >((s) => s.cases.showRecommendedGroups);
  useEffect(() => {
    if (isYourAssignments && (activeTab === "groups/behavior" || activeTab === "groups/reading") 
      && !isStudentDetail && showRecommendedGroups) {
      dispatch(getRecommendations());
    }
  }, [currentDataPeriod?.id, activeTab, showRecommendedGroups]);

  useEffect(() => {
    Object.keys(collapsedStates).forEach((stateCaseId) => {
      if (collapsedStates[stateCaseId]) {
        const caseLoadId = stateCaseId.split('_')[3];
        if (!caseInterventionGroups[caseLoadId] || !caseInterventionGroups[caseLoadId].length) { // Fetch only if not already loaded
          dispatch(getInterventionGroups((showArchivedGroups || (displayGroupChange == 'archived')), activeTab, student?.id, caseLoadId, stateCaseId, (exitedStudentsGroup || (displayGroupChange == 'exited_groups'))));
        }
      }
    });
  }, [collapsedStates]); // Trigger when any collapse state changes

  const { highlightGroup } = useHighlightGroupCard();
  useEffect(() => {
    setTimeout(() => {
      if(isGroupCreated) {
        if(Object.keys(caseInterventionGroups).length){
            highlightGroup(
              `employee_assignment_${isTeacher ? selectedInterventionGroup?.coach_assignment?.user.id :selectedInterventionGroup?.teacher_assignment?.user.id}`,
              selectedInterventionGroup?.id
            );
            dispatch(resetGroupCreated());
          // const caseId: number = 
          //   isTeacher 
          //   ? selectedInterventionGroup?.coach_assignment?.user.id! 
          //   : selectedInterventionGroup?.teacher_assignment?.user.id!
          // setCollapsedStates((prevStates: any) => ({
          //   ...prevStates,
          //   [caseId]: !prevStates[caseId], // Toggle the state for the specific case_id
          // }));
          // const groupCard = document.getElementById(`group_card_${selectedInterventionGroup?.id}`);
          // if (groupCard) {
          //   groupCard.scrollIntoView();
          //   groupCard.classList.add("highlighted");
          //   setTimeout(() => groupCard.classList.remove("highlighted"), 1500);
          //   dispatch(resetGroupCreated());
          // }
        }
      }
    },1000)
  },[isGroupCreated, caseInterventionGroups, selectedInterventionGroup?.id])

  const historyURL = createBrowserHistory();
  const { changeActiveTab } = useActiveTab();
  
  useEffect(() => {
    return historyURL.listen((location, action) => {
      if(isYourAssignments && (tabName === "groups/behavior" || tabName === "groups/reading")) {
        if(action == 'POP') {
          changeActiveTab(tabName);
          dispatch(hideInterventionPlanModal());
        }  
      }
    })
  },[tabName])

  useEffect(() => {
    if (isYourAssignments || isDistrictOwner) {
      dispatch(getSkillFocuses());
    }
  }, [isYourAssignments, tabName, displayGroupChange]);
  


  const teachers = useSelector<ApplicationState, TeacherInfo[]>(
    (s) => s.onboarding.teachersRosterWithDummyUser
  );

  const coaches = useSelector<ApplicationState, CoachInfo[]>(
    (s) => s.onboarding.coachesRosterWithDummyUser
  );

  useEffect(() => {
    if(activeTab 
      && ((activeTab == '/groups/reading') 
          || (activeTab == '/groups/behavior') 
          || (activeTab == '/students')
      )
      ) {
      if (!coaches.length) {
        dispatch(getCoaches());
      }
      if (!teachers.length && !isLoading.getTeachers) {
        dispatch(getTeachers());
      }
    }
  }, []);

  const { onDragStart, onDragEnd } = useGroupCardDragging();

  const handleCollapse = (caseLoadUserId: number, caseLoadType:string) => {
    changeIntGroupAssigmentCollapsedSettings({
      id: caseLoadUserId,
      collapsed: !collapsed,
    });
    setCollapsed((pS) => !pS);
    setCollapsedStates((prevStates: any) => ({
      ...prevStates,
      [caseLoadType + caseLoadUserId]: !prevStates[caseLoadType + caseLoadUserId], // Toggle the state for the specific case_id
    }));
  };

  const activeView = useSelector<ApplicationState, "list" | "grid">(
    (s) => s.cases.activeGroupsView
  );

  const isShowOverviewAllGroupBtn = useMemo(() => {
    return (
      (isCoach || isTeacher) && isStudentDetail 
      ? //if shared data with and not shared data with user available
        (caseLoadUsers?.some((caseLoadUser: CaseLoadUser) => !caseLoadUser.share_data_with)
        && caseLoadUsers.some((caseLoadUser: CaseLoadUser) => caseLoadUser?.share_data_with))
        // if only share data with user available
        || (caseLoadUsers.some((caseLoadUser: CaseLoadUser) => caseLoadUser?.share_data_with))
      : true
    );
  }
  , [caseLoadUsers, isCoach, isTeacher]);
  
  return (
    <>
      <div id="groups-container">
        {!isParent && (
          <>
            <div className="mb-3">
              <ToolBar
                isYourAssignments={isYourAssignments}
                student={student}
                activeTab={activeTab}
                isShowOverviewAllGroupBtn = {isShowOverviewAllGroupBtn}
              />
            </div>
            {student && <hr />}
            {isYourAssignments && !showArchivedGroups && <RecommendationsSection />}
          </>
        )}
      </div>
      {isLoading.getCaseLoadUsers || isLoading.discontinueIntGroupInt ? (
          <LoadingIndicator  type="caseload-list"  itemCount={7} />
        ) : caseLoadUsers?.length ? (
          <div className={groupSort ? "sorted-groups-container" : undefined}>
          {!isStudentDetail && (isCoach || isTeacher) && 
            <>
              {caseLoadUsers.filter((caseLoadUser: any) => !caseLoadUser.read_only_access).map((caseLoadUser: any, i) => {
                const editCaseId = `edit_${i}_${!caseLoadUser.read_only_access}_`+caseLoadUser.case_id;
                const isCollapsed: boolean = (collapsedStates[editCaseId]) || (isLoading.getInterventionGroups && (isLoading.getCaseId == editCaseId));
               return <div key={editCaseId}>
                <div
                  data-cy={`employee_assignment_${caseLoadUser.case_id}`}
                  id={`employee_assignment_${caseLoadUser.case_id}`}
                  className="assigmentCollapseHeader"
                  aria-controls={`assigment-collapse_${caseLoadUser.case_id}`}
                  aria-expanded={isCollapsed}
                  onClick={() => handleCollapse(caseLoadUser.case_id, `edit_${i}_${!caseLoadUser.read_only_access}_`)}
                >
                {/* {( caseLoadUser?.share_data_with || displayGroupChange == 'archived') && !groupSort && (  */}
                  <span className="mr-3">
                    <FontAwesomeIcon
                      icon={isCollapsed ? faCaretDown : faCaretRight}
                      size="2x"
                    />
                  </span>
                {/* )} */}
                <span className="mr-3">
                <Image
                  style={{
                    objectFit: "cover",
                    objectPosition: "top center",
                    border: "1px solid #616161",
                  }}
                  src={caseLoadUser.profile_image_url}
                  width={30}
                  height={30}
                  roundedCircle
                />
                </span>
                <h2>{caseLoadUser.case_name}</h2>

                {!isParent && !isCollapsed && !!caseLoadUser.alert_count && (
                  <SvgCircle
                    svgSize={30}
                    text={caseLoadUser.alert_count}
                    className="notificationBubble mx-2"
                  />
                )}
                {//caseLoadUser?.share_data_with ?
                    <button
                      className="ml-2 blueBtnSm"
                      onClick={(e) => {
                        e.stopPropagation();
                        dispatch(openInterventionStatsModal(caseLoadUser));
                        dispatch(openOverviewModel('one_educator'));
                      }}
                    >
                      Show Overview
                    </button>
                  // :
                  // ''
                }
                {isCollapsed 
                && caseInterventionGroups[caseLoadUser.case_id] 
                && caseInterventionGroups[caseLoadUser.case_id].length > 1 
                ? <button
                  className="ml-2 whiteBtnSm"
                  onClick={(e) => {
                    e.stopPropagation();
                    dispatch(openGroupReorderModal({
                      interventionGroupsForReorder: caseInterventionGroups[caseLoadUser.case_id],
                      selectedCaseId: caseLoadUser.case_id,
                    }));
                  }}
                >
                  Group Reorder
                </button> : ''}
                </div>
                <Collapse in={isCollapsed}>
                  <div id={`assigment-collapse_${caseLoadUser.case_id}`}>
                    <div className={`assigmentInfo ${activeView}`}>
                          { isLoading.getInterventionGroups && (isLoading.getCaseId == editCaseId)
                           || isLoading.createInterventionGroup
                            ? 
                              <LoadingIndicator type="card" cardCount={3} />
                            :
                              caseInterventionGroups[caseLoadUser.case_id] ?
                                <InterventionsGroup
                                  editAccessKey={`teacher_edit_${i}`}
                                  isReadonly={isParent}
                                  interventionGroups={groupReorderSorting(caseInterventionGroups[caseLoadUser.case_id], caseLoadUser.case_id)}
                                  // interventionGroups={caseInterventionGroups[caseLoadUser.case_id]?.filter(
                                  //   (group) => !group.additional_educator_plan?.some(
                                  //               (plan) => plan.user_id === currentUserInfo?.id)
                                  // )}
                                  student={student}
                                  teachers={teachers}
                                  coaches={coaches}
                                  isTeacher={isTeacher}
                                  isCoach={isCoach}
                                  isDistrictOwner={isDistrictOwner}
                                  onDragStart={onDragStart}
                                  onDragEnd={onDragEnd}
                                  notShareDataWith={false}
                                  isYourAssignments={isYourAssignments}
                                  caseId = {caseLoadUser.case_id}
                                  // intGrpIDsWithEditAccess={intGrpIDsWithEditAccess}
                                  // onIntGrpIDsWithEditAccess={(interventionGroupId: number) => 
                                  //   setIntGrpIDsWithEditAccess((intGrpIDsWithEditAccess) => 
                                  //     [...intGrpIDsWithEditAccess, interventionGroupId])
                                  // }
                                /> 
                              :
                              <Alert variant="warning">
                                Please wait, we are loading... 
                                {/*   Use this below option if required in future.
                                      loader_info: {
                                        edit_{index}_{case_id}: true/false,
                                        read_{index}_{case_id}: true/false,
                                      }
                                      set this structure at initial caseload response list. 
                                 */}
                              </Alert>
                          }
                    </div>
                  </div>
                </Collapse> 
              </div>
              })}
              {caseLoadUsers.filter((caseLoadUser: any) => caseLoadUser.read_only_access).map((caseLoadUser: any, j) => {
                const readCaseId = `read_${j}_${caseLoadUser.read_only_access}_`+caseLoadUser.case_id;
                const isCollapsed: boolean = collapsedStates[readCaseId] || (isLoading.getInterventionGroups && (isLoading.getCaseId == readCaseId));
                return <div key={readCaseId}>
                  {j == 0 && 
                    <>
                      <hr/>  
                      <h3>Groups with Read-Only Access</h3> 
                    </>
                  }
                <div
                  data-cy={`employee_assignment_${caseLoadUser.case_id}`}
                  id={`employee_assignment_${caseLoadUser.case_id}`}
                  className="assigmentCollapseHeader"
                  aria-controls={`assigment-collapse_${caseLoadUser.case_id}`}
                  aria-expanded={isCollapsed}
                  onClick={() => handleCollapse(caseLoadUser.case_id, `read_${j}_${caseLoadUser.read_only_access}_`)}
                >
                {/* {( caseLoadUser?.share_data_with || displayGroupChange == 'archived') && !groupSort && (  */}
                  <span className="mr-3">
                    <FontAwesomeIcon
                      icon={isCollapsed ? faCaretDown : faCaretRight}
                      size="2x"
                    />
                  </span>
                {/* )} */}
                <span className="mr-3">
                <Image
                  style={{
                    objectFit: "cover",
                    objectPosition: "top center",
                    border: "1px solid #616161",
                  }}
                  src={caseLoadUser.profile_image_url}
                  width={30}
                  height={30}
                  roundedCircle
                />
                </span>
                <h2>{caseLoadUser.case_name}</h2>

                {!isParent && !isCollapsed && !!caseLoadUser.alert_count && (
                  <SvgCircle
                    svgSize={30}
                    text={caseLoadUser.alert_count}
                    className="notificationBubble mx-2"
                  />
                )}
                {//caseLoadUser?.share_data_with ?
                    <button
                      className="ml-2 blueBtnSm"
                      onClick={(e) => {
                        e.stopPropagation();
                        dispatch(openInterventionStatsModal(caseLoadUser.user));
                        dispatch(openOverviewModel('one_educator'));
                      }}
                    >
                      Show Overview
                    </button>
                  // :
                  // ''
                }
                </div>
                <Collapse in={isCollapsed}>
                  <div id={`assigment-collapse_${caseLoadUser.case_id}`}>
                    <div className={`assigmentInfo ${activeView}`}>
                    { isLoading.getInterventionGroups && (isLoading.getInterventionGroups && (isLoading.getCaseId == readCaseId))
                       || isLoading.createInterventionGroup
                        ? 
                          <LoadingIndicator />
                        :
                          caseInterventionGroups[caseLoadUser.case_id] ? 
                            <InterventionsGroup
                              isReadonly={isParent}
                              // interventionGroups={caseInterventionGroups[caseLoadUser.case_id]?.filter(
                              //   (group) => 
                              //     (group.coach_assignment?.user.id !== currentUserInfo?.id) &&
                              //     (group.teacher_assignment?.user.id !== currentUserInfo?.id) &&
                              //     group.additional_educator_plan?.some(
                              //               (plan) => plan.user_id === currentUserInfo?.id)
                              // )}
                              interventionGroups={caseInterventionGroups[caseLoadUser.case_id]}
                              student={student}
                              readAccessKey={`teacher_read_${j}`}
                              teachers={teachers}
                              coaches={coaches}
                              isTeacher={isTeacher}
                              isCoach={isCoach}
                              isDistrictOwner={isDistrictOwner}
                              onDragStart={onDragStart}
                              onDragEnd={onDragEnd}
                              //shareDataWith={false}
                              notShareDataWith={false}
                              isYourAssignments={isYourAssignments}
                              // intGrpIDsWithReadAccess={intGrpIDsWithReadAccess}
                              // onIntGrpIDsWithReadAccess={(interventionGroupId: number) => 
                              //   setIntGrpIDsWithReadAccess((intGrpIDsWithReadAccess) => 
                              //     [...intGrpIDsWithReadAccess, interventionGroupId])
                              // }
                            />
                           :
                          <Alert variant="warning">
                            Please wait, we are loading... 
                              {/*   Use this below option if required in future.
                                  loader_info: {
                                    edit_{index}_{case_id}: true/false,
                                    read_{index}_{case_id}: true/false,
                                  }
                                  set this structure at initial caseload response list. 
                              */}
                          </Alert>
                    }
                    </div>
                  </div>
                </Collapse> 
                </div>
              })}
            </>
          }
          {isStudentDetail && (isCoach || isTeacher) ?
            <>
              {caseLoadUsers.filter((caseLoadUser: any) => caseLoadUser?.share_data_with)?.length ? 
                <Accordion className="cardAcc" defaultActiveKey="0">
                  <Card>
                    <Card.Header>
                      <Accordion.Toggle as={Button} variant="" eventKey="0" onClick={() => setOpenShareData(!openShareData)}>
                        {openShareData ? <FontAwesomeIcon icon={faAngleUp} /> : <FontAwesomeIcon icon={faAngleDown} /> }
                        {isCoach && caseLoadUsers.filter((caseLoadUser: any) => caseLoadUser?.share_data_with)?.length ? ` Teachers you share data with OR groups for whom you are a Coach.`  : ''}
                        {isTeacher && caseLoadUsers.filter((caseLoadUser: any) => caseLoadUser?.share_data_with)?.length ? ` Coaches you share data with OR groups for whom you are an Interventionist.`  : ''}
                      </Accordion.Toggle>
                    </Card.Header>
                  <Accordion.Collapse eventKey="0">
                    <div className="ml-2 p-3">
                    {caseLoadUsers.filter((caseLoadUser: any) => caseLoadUser?.share_data_with).map((caseLoadUser: any, k) => {
                      const sharedCaseId = `edit_${k}_${caseLoadUser.share_data_with}_`+caseLoadUser.case_id;
                      const isCollapsed: boolean = (collapsedStates[sharedCaseId]) || (isLoading.getInterventionGroups && (isLoading.getCaseId == sharedCaseId));
                      return <div key={sharedCaseId}>
                          <div
                            data-cy={`employee_assignment_${caseLoadUser.case_id}`}
                            id={`employee_assignment_${caseLoadUser.case_id}`}
                            className="assigmentCollapseHeader"
                            aria-controls={`assigment-collapse_${caseLoadUser.case_id}`}
                            aria-expanded={isCollapsed}
                            onClick={() => handleCollapse(caseLoadUser.case_id, `edit_${k}_${caseLoadUser?.share_data_with}_`)}
                          >
                          {( caseLoadUser?.share_data_with || displayGroupChange == 'archived') && !groupSort && ( 
                            <span className="mr-3">
                              <FontAwesomeIcon
                                icon={isCollapsed ? faCaretDown : faCaretRight}
                                size="2x"
                              />
                            </span>
                          )}
                          <span className="mr-3">
                          <Image
                            style={{
                              objectFit: "cover",
                              objectPosition: "top center",
                              border: "1px solid #616161",
                            }}
                            src={caseLoadUser.profile_image_url}
                            width={30}
                            height={30}
                            roundedCircle
                          />
                          </span>
                          <h2>{caseLoadUser.case_name}</h2>

                          {!isParent && !isCollapsed && !exitedStudentsGroup && !!caseLoadUser.alert_count && (
                            <SvgCircle
                              svgSize={30}
                              text={caseLoadUser.alert_count}
                              className="notificationBubble mx-2"
                            />
                          )}
                          {caseLoadUser?.share_data_with ?
                              <button
                                className="ml-2 blueBtnSm"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  dispatch(openInterventionStatsModal(caseLoadUser));
                                  dispatch(openOverviewModel('one_educator'));
                                }}
                              >
                                Show Overview
                              </button>
                            :
                            ''
                          }
                          </div>
                          <Collapse in={isCollapsed}>
                            <div id={`assigment-collapse_${caseLoadUser.case_id}`}>
                              <div className={`assigmentInfo ${activeView}`}>
                                    { isLoading.getInterventionGroups && (isLoading.getInterventionGroups && (isLoading.getCaseId == sharedCaseId))
                                      ? 
                                        <LoadingIndicator />
                                      :
                                      caseInterventionGroups[caseLoadUser.case_id] ? 
                                        <InterventionsGroup
                                          isReadonly={isParent}
                                          interventionGroups={caseInterventionGroups[caseLoadUser.case_id]}
                                          student={student}
                                          key={`teacher_${k}`}
                                          teachers={teachers}
                                          coaches={coaches}
                                          isTeacher={isTeacher}
                                          isCoach={isCoach}
                                          isDistrictOwner={isDistrictOwner}
                                          onDragStart={onDragStart}
                                          onDragEnd={onDragEnd}
                                          notShareDataWith={false}
                                          isYourAssignments={false}
                                          caseId = {caseLoadUser.case_id}
                                        /> 
                                        :
                                        <Alert variant="warning">
                                          Please wait, we are loading... 
                                            {/*   Use this below option if required in future.
                                                loader_info: {
                                                  edit_{index}_{case_id}: true/false,
                                                  read_{index}_{case_id}: true/false,
                                                }
                                                set this structure at initial caseload response list. 
                                            */}
                                        </Alert>
                                    }
                              </div>
                            </div>
                          </Collapse> 
                        </div>
                      })
                    }
                    </div>
                  </Accordion.Collapse>
                </Card>
                </Accordion>
                : ''
              } 
              {caseLoadUsers.filter((caseLoadUser: any) => !caseLoadUser?.share_data_with)?.length ?  
                <Card>
                  <Card.Header>
                      {isCoach && caseLoadUsers.filter((caseLoadUser: any) => !caseLoadUser?.share_data_with)?.length ? ` Teachers you do not share data with OR groups for whom you are not a Coach.` : ''}
                      {isTeacher && caseLoadUsers.filter((caseLoadUser: any) => !caseLoadUser?.share_data_with)?.length ? ` Coaches you do not share data with OR groups for whom you are not an Interventionist.` : ''}
                  </Card.Header>
                  <Card.Body>
                    <div className="px-2">
                    {caseLoadUsers.filter((caseLoadUser: any) => !caseLoadUser?.share_data_with)?.map((caseLoadUser: any, k) => {
                    return <div key={k}>
                      <div
                          className="assigmentCollapseHeader"
                        >
                        <span className="mr-3">
                        <Image
                          style={{
                            objectFit: "cover",
                            objectPosition: "top center",
                            border: "1px solid #616161",
                          }}
                          src={caseLoadUser.profile_image_url}
                          width={30}
                          height={30}
                          roundedCircle
                        />
                        </span>
                        <h2>{caseLoadUser.case_name}</h2>
                      </div>
                      </div>
                    })
                  } 
                    </div>          
                  </Card.Body>
                </Card>
              : ''}
            </>
          : ''
         }
         {isStudentDetail && isDistrictOwner && <>
              {caseLoadUsers.filter((caseLoadUser: any) => !caseLoadUser.read_only_access).map((caseLoadUser: any, l) => {
                const editCaseIdByStudent = `edit_${l}_${!caseLoadUser.read_only_access}_`+caseLoadUser.case_id
                const isCollapsed: boolean = (collapsedStates[editCaseIdByStudent]) || (isLoading.getInterventionGroups && (isLoading.getCaseId == editCaseIdByStudent));
             return <div key={l}>
                <div
                  data-cy={`employee_assignment_${caseLoadUser.case_id}`}
                  id={`employee_assignment_${caseLoadUser.case_id}`}
                  className="assigmentCollapseHeader"
                  aria-controls={`assigment-collapse_${caseLoadUser.case_id}`}
                  aria-expanded={isCollapsed}
                  onClick={() => handleCollapse(caseLoadUser.case_id, `edit_${l}_${!caseLoadUser.read_only_access}_`)}
                >
                {/* {( caseLoadUser?.share_data_with || displayGroupChange == 'archived') && !groupSort && (  */}
                  <span className="mr-3">
                    <FontAwesomeIcon
                      icon={isCollapsed ? faCaretDown : faCaretRight}
                      size="2x"
                    />
                  </span>
                {/* )} */}
                <span className="mr-3">
                <Image
                  style={{
                    objectFit: "cover",
                    objectPosition: "top center",
                    border: "1px solid #616161",
                  }}
                  src={caseLoadUser.profile_image_url}
                  width={30}
                  height={30}
                  roundedCircle
                />
                </span>
                <h2>{caseLoadUser.case_name}</h2>

                {!isParent && !isCollapsed && !exitedStudentsGroup && !!caseLoadUser.alert_count && (
                  <SvgCircle
                    svgSize={30}
                    text={caseLoadUser.alert_count}
                    className="notificationBubble mx-2"
                  />
                )}
                {caseLoadUser.case_id ==  currentUserInfo?.id ?
                //we are not shown in the district admin so apply the condition same as isUserAssignedToGroup(intervention plan modal)
                    <button
                      className="ml-2 blueBtnSm"
                      onClick={(e) => {
                        e.stopPropagation();
                        dispatch(openInterventionStatsModal(caseLoadUser));
                        dispatch(openOverviewModel('one_educator'));
                      }}
                    >
                      Show Overview
                    </button>
                  :
                  ''
                }
                </div>
                <Collapse in={isCollapsed}>
                  <div id={`assigment-collapse_${caseLoadUser.case_id}`}>
                    <div className={`assigmentInfo ${activeView}`}>
                          { isLoading.getInterventionGroups && (isLoading.getInterventionGroups && (isLoading.getCaseId == editCaseIdByStudent))
                          || isLoading.createInterventionGroup
                            ? 
                              <LoadingIndicator />
                            :
                              caseInterventionGroups[caseLoadUser.case_id] ?
                                <InterventionsGroup
                                  isReadonly={isParent}
                                  interventionGroups={caseInterventionGroups[caseLoadUser.case_id]}
                                  student={student}
                                  teachers={teachers}
                                  coaches={coaches}
                                  isTeacher={isTeacher}
                                  isCoach={isCoach}
                                  isDistrictOwner={isDistrictOwner}
                                  onDragStart={onDragStart}
                                  onDragEnd={onDragEnd}
                                  notShareDataWith={false}
                                  isYourAssignments={isYourAssignments}
                                  caseId = {caseLoadUser.case_id}
                                  // intGrpIDsWithEditAccess={intGrpIDsWithEditAccess}
                                  // onIntGrpIDsWithEditAccess={(interventionGroupId: number) => 
                                  //   setIntGrpIDsWithEditAccess((intGrpIDsWithEditAccess) => 
                                  //     [...intGrpIDsWithEditAccess, interventionGroupId])
                                  // }
                                /> 
                              :
                              <Alert variant="warning">
                                Please wait, we are loading... 
                                {/*   Use this below option if required in future.
                                      loader_info: {
                                        edit_{index}_{case_id}: true/false,
                                        read_{index}_{case_id}: true/false,
                                      }
                                      set this structure at initial caseload response list. 
                                 */}
                              </Alert>
                          }
                    </div>
                  </div>
                </Collapse> 
              </div>
              })}
            </>
            }
          {!(isParent || isSupervisor || isTeacher) && isYourAssignments && (
            <>
              <InterventionFidelityTour />
              <FidelityChartTour />
            </>
          )}
        </div>
        ) : groupSearch.length ? (
          <Alert variant="warning">
            No matching interventions groups. Try to change the search options
          </Alert>
        ) : !isStudentDetail && showArchivedGroups ? (
          <Alert variant="warning">
            You don&apos;t have archived groups{student && " with this student"}
            .
          </Alert>
        ) : isStudentDetail ? 
              <>
                {showArchivedGroups &&
                  <span className="alert alert-warning p-1">
                    There are no archived groups for this student.
                </span>}
                {exitedStudentsGroup &&
                  <span className="alert alert-warning p-1">
                    There are no exited groups for this student.
                </span>}
                {!exitedStudentsGroup && !showArchivedGroups &&
                  <span className="alert alert-warning p-1">
                    There are no active groups for this student.
                </span>}
              </>
        : ''
        // (student || !interventionGroupsMap?.length) && (
        //   <Alert variant="warning">
        //     Student doesn&apos;t have any groups yet.
        //   </Alert>
        // )
      }

     
      <InterventionStatsModal student ={student}/>
      <GroupReorderModal />
      <AddInterventionModal />
    </>
  );
};

const mapStateToProps = ({
  onboarding,
  dataFilter,
  auth,
  cases
}: ApplicationState): StateProps => {
  return {
    collapsedIntGroupAssignmentsIds: onboarding.collapsedIntGroupAssignmentsIds,
    caseLoadUserList: onboarding.caseLoadUsers,
    caseInterventionGroups: cases.caseInterventionGroups,
    isGroupCreated: cases.isGroupCreated,
    selectedInterventionGroup: cases.selectedInterventionGroup,
    isLoading: {
      getCaseLoadUsers: onboarding.isLoading.getCaseLoadUsers,
      getInterventionGroups: cases.isLoading.getInterventionGroups,
      createInterventionGroup: cases.isLoading.createInterventionGroup,
      getTeachers: onboarding.isLoading.getTeachers,
      getCaseId: cases.isLoading.getCaseId,
      discontinueIntGroupInt: cases.isLoading.discontinueIntGroupInt,
    },
    errors: {
      getCaseLoadUsers: onboarding.errors.getCaseLoadUsers,
      getInterventionGroups: cases.errors.getInterventionGroups,
    },
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
  return bindActionCreators(
    {
      push: push,
      changeIntGroupAssigmentCollapsedSettings: changeIntGroupAssigmentCollapsedSettings,
      getCaseLoadUsers: getCaseLoadUsers,
      getInterventionGroups: getInterventionGroups,
      resetGroupCreated: resetGroupCreated
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CaseLoadUserList);